/* The key button (one key picker everywhere, #3004, spec §4): a quiet label, then the song key chip's look */
.row {
  display: inline-flex;
  align-items: center;
  gap: var(--tuna-spacing-1);
}

.label {
  font-size: var(--tuna-typography-fontSize-sm);
  color: var(--tuna-palette-text-secondary);
}

/* The song key chip (plugins/song/src/key/song-key-chip.module.css): the same tokens, the whole chip clickable */
.chip {
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  padding: 0 var(--tuna-spacing-1_5);
  border: 1px solid transparent;
  border-radius: var(--tuna-shape-radius-pill);
  background-color: var(--tuna-palette-action-selected);
  color: var(--tuna-palette-text-primary);
  font-family: inherit;
  font-size: var(--tuna-typography-fontSize-sm);
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
}

.chip:hover {
  background-color: var(--tuna-palette-action-hover);
}

.chip:focus-visible,
.done:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
}

/* 44 px on touch (WCAG 2.5.8) */
@media (pointer: coarse) {
  .chip {
    min-height: 44px;
  }
}

/* Spec §6: 284 px wide, so a 16 px gutter remains at 320 px */
.picker {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1_5);
  width: 284px;
  max-width: 100%;
  padding: var(--tuna-spacing-2);
  box-sizing: border-box;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title {
  margin: 0;
  font-size: var(--tuna-typography-body1-fontSize);
  font-weight: 600;
  color: var(--tuna-palette-text-primary);
}

.done {
  min-height: 44px;
  padding: 0 var(--tuna-spacing-1);
  border: none;
  background: none;
  border-radius: var(--tuna-shape-borderRadius);
  font: inherit;
  color: var(--tuna-palette-primary-main);
  cursor: pointer;
}
